import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { first } from 'rxjs/operators';
import { RootState } from '@root/app.state';

import * as PlatformActions from '@platform/platform.actions';
import { selectPortalSettings } from '@platform/platform.selectors';
import { go } from '@platform/router.actions';
import { CustomIconService } from '@platform/shared/custom-icon.service';
import { firstValueFrom } from 'rxjs';
import { ResourceStatuses } from '@platform/shared/resource.state';

@Injectable({
  providedIn: 'root',
})
export class AppInitializationService {
  constructor(
    private store$: Store<RootState>,
    private customIconService: CustomIconService,
  ) {}

  public async initializeApp(): Promise<void> {
    this.customIconService.init();
    this.store$.dispatch(PlatformActions.loadPortalSettings());

    // we wait for the oidc config to be loaded before we start the app
    const portalSettings = await firstValueFrom(
      this.store$.pipe(
        select(selectPortalSettings),
        first((state) => state.status === ResourceStatuses.SUCCEEDED || state.status === ResourceStatuses.FAILED),
      ),
    );

    // make sure the selector has the correct state afterwards
    selectPortalSettings.release();

    if (portalSettings.status === ResourceStatuses.FAILED) {
      this.store$.dispatch(go({ path: ['fatal-error'] }));
    }
  }
}
